export function noop(): void { }

export const inBrowser = typeof window !== 'undefined'
